import React, { useState, useEffect } from "react";
import { Fragment } from "react";
import { Helmet } from "react-helmet";
import { EditData, GetData, DeleteData } from "./Components/Services";
import DataTable from "../../../Common/Components/DataTable";
import CommonFrom from "../../../Common/Components/Form";
import Loading from "../../../Common/Components/Loading";
import CustomModal from "../../../Common/Components/Modal/CustomModal";

import { input } from "./Create";
function List() {
  const initialState = {
    loading: false,
    data: {
      data: null,
      current_page: null,
    },
    modal: false,
  };
  const [state, setstate] = useState(initialState);
  useEffect(() => {
    Handler();
  }, []);
  const Handler = (pageNumber = 1, limit, index) => {
    setstate({ ...state, loading: true });
    GetData(pageNumber, limit, index).then(result => {
      setstate({
        loading: false,
        data: result,
      });
    });
  };

  const HandlerDelete = data => {
    setstate({ ...state, loading: true });
    DeleteData(data).then(() => {
      GetData().then(result => {
        setstate({
          loading: false,
          data: result,
        });
      });
    });
  };

  const HandlerEdit = data => {
    setstate({ ...state, loading: true });
    EditData({
      ...data,
      category_id:
        state.data &&
        state.data.data &&
        state.data.data.filter(data => data.id == state.modal)[0].id,
    });
    GetData().then(result => {
      setstate({
        loading: false,
        data: result,
      });
    });
  };
  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | دسته بندی ها</title>
      </Helmet>

      <DataTable
        heads={[
          {
            title: "عنوان",
            key: "name",
          },
          {
            title: "توضیحات",
            key: "description",
          },
          {
            title: "اخرین بروز رسانی",
            key: "updated_at",
            type: "date",
            timetype: "date-time",
          },
        ]}
        textEmpty="دسته بندی ثبت نشده است"
        list={state.data.data}
        data={state.data}
        function={Handler}
        loading={state.loading}
        currentPage={state.data && state.data.current_page}
        header="لیست دسته بندی مقالات"
        textbtn="ایجاد دسته بندی مقالات"
        linkbtn="/Admin/blogCategory/Create"
        links={[
          {
            function: selected => {
              HandlerDelete({ category_id: selected });
            },
            color: "danger",
            size: "col-md-2",
            html: "حذف",
            multi: true,
            type: "delete",
          },
          {
            function: selected => {
              setstate({ ...state, modal: selected[0] });
            },
            color: "info",
            type: "key",
            size: "col-md-2",
            html: "ویرایش",
            type: "edit",
            main: true,
          },
        ]}
      />

      <CustomModal
        show={state.modal}
        handleClose={() => {
          setstate({ ...state, modal: false });
        }}
        header={"ویرایش دسته بندی"}
      >
        <CommonFrom
          loading={state.loading}
          form={input}
          btnName={"ثبت اطلاعات دسته بندی"}
          value={
            state.data &&
            state.data.data &&
            state.data.data.filter(data => data.id == state.modal)[0]
          }
          submit={HandlerEdit}
          edit={true}
        />
      </CustomModal>
    </Fragment>
  );
}

export default List;
